import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import api from "@/lib/api";

export const GroupPicker = ({ groups, value, onChange }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!value.length) { setCount(0); return; }
        api.get("/mailing/audience", { params: { group_ids: value.join(",") } })
            .then((r) => setCount(r.data?.count || 0)).catch(() => setCount(0));
    }, [value]);

    const toggle = (id) => onChange(value.includes(id) ? value.filter((g) => g !== id) : [...value, id]);

    return (
        <div data-testid="mailing-group-picker">
            <div className="flex flex-wrap gap-2">
                {groups.map((g) => {
                    const active = value.includes(g.id);
                    return (
                        <button key={g.id} type="button" onClick={() => toggle(g.id)} data-testid={`mailing-group-chip-${g.id}`}
                            className={`inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border text-sm transition-colors ${active ? "border-[#0D4F3C] bg-[#0D4F3C] text-white" : "border-gray-200 text-[#092E22] hover:border-[#0D4F3C]/40"}`}>
                            <span className="w-2 h-2 rounded-full" style={{ background: g.color }} />
                            {g.name}
                            <span className={`text-[10px] font-mono ${active ? "text-white/70" : "text-gray-400"}`}>{g.count}</span>
                        </button>
                    );
                })}
            </div>
            <p className="mt-3 inline-flex items-center gap-2 text-sm text-[#0D4F3C]" data-testid="mailing-audience-count">
                <Users size={14} /> Unikalnych odbiorców: <strong>{count}</strong>
                <span className="text-xs text-gray-400">(bez duplikatów i wypisanych)</span>
            </p>
        </div>
    );
};

export default GroupPicker;
